var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoltPlusAuthLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 31,
    viewBox: "0 0 120 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9855 3.12524C30.5345 3.19027 25.6682 7.55578 25.7341 15.1324C25.8 22.7088 30.7424 26.9887 38.193 26.924C45.644 26.859 50.5107 22.4933 50.4444 14.9167C50.3785 7.34016 45.4361 3.06021 37.9855 3.12524ZM2.15962 26.6097L13.8233 26.5078C18.1302 26.4702 23.3037 24.8528 23.2593 19.7599C23.2348 16.9777 21.5388 15.3734 18.9385 14.6415C21.1336 13.9778 22.424 12.3316 22.4041 10.0209C22.3606 5.03797 17.4934 3.93288 13.3906 3.96867L1.96289 4.06843L2.15962 26.6097ZM8.76059 21.0343L8.73152 17.7017L13.746 17.6579C14.9561 17.6474 16.4662 17.7442 16.4798 19.3002C16.4933 20.8564 14.9853 20.9798 13.7751 20.9904L8.76059 21.0343ZM13.4662 12.6142L8.6875 12.6559L8.66033 9.54347L13.4388 9.50181C14.5234 9.49234 15.6888 9.73369 15.7002 11.0384C15.7116 12.343 14.5509 12.6047 13.4662 12.6142ZM60.1391 3.56071L60.2874 20.5687L71.0865 20.4745L71.1347 26.0076L53.6865 26.1597L53.49 3.61876L60.1391 3.56071ZM67.6851 9.0284L75.0575 8.96404L75.2058 25.9721L81.8553 25.9142L81.7065 8.90603L89.0789 8.84168L89.0308 3.30858L67.6369 3.4953L67.6851 9.0284ZM34.4777 20.9663L44.0869 15.3061L34.3805 9.81444L34.4777 20.9663Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.733 4.00169L108.453 3.96924L108.536 13.5048L117.943 13.4227L117.973 16.8436L108.566 16.9257L108.649 26.5041L104.929 26.5367L104.846 16.9581L95.4812 17.0399L95.4512 13.619L104.816 13.5373L104.733 4.00169Z",
    fill: "url(#paint0_linear_13670_6734)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13670_6734",
    x1: 98.9147,
    y1: 25.1905,
    x2: 111.733,
    y2: 8.85168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0129585,
    stopColor: "#454AEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61C2ED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoltPlusAuthLogo);
export default __webpack_public_path__ + "static/media/boltPlusAuthLogo.d6f87c17c85c321351cb1657942a2a47.svg";
export { ForwardRef as ReactComponent };